// extracted by mini-css-extract-plugin
module.exports = {"reviews__item":"r_9","reviews__item__author":"r_bb","reviews__item__date":"r_bc","reviews__item__stars":"r_bd","reviews__item__star__active":"r_bf","reviews__item__content":"r_bg"};